var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('PostForm',{attrs:{"payload":_vm.article,"submit-text":'수정하기'},on:{"update:payload":_vm.updatePayload,"submit":_vm.processEdit,"cancel":_vm.moveToDetail}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }